import { Reach } from '~/tenants/bre/performable/boost/BreBoostConfig';

type ReachMap = Record<Reach, {revenue: string; expense: string}>;

export const BreBoostRate: ReachMap = {
  '3,000': { expense: '150.00', revenue: '200' },
  '5,000': { expense: '230.00', revenue: '300' },
  '7,000': { expense: '335.00', revenue: '400' },
  '9,250': { expense: '410.00', revenue: '500' },
  '11,500': { expense: '480.00', revenue: '600' },
  '14,000': { expense: '550.00', revenue: '700' },
  '16,500': { expense: '620.00', revenue: '800' },
  '20,000': { expense: '690.00', revenue: '900' },
  '24,000': { expense: '760.00', revenue: '1000' }
  };
